import {Injectable} from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class Sessioncommand
{
  public static staffId : number = Number(sessionStorage.getItem('staffId'));
  public static userId: number= Number(sessionStorage.getItem('userId'));
  public static maDonVi: number = Number(sessionStorage.getItem('maDonVi'));
  public static notification: boolean = false;
  public static giaiQuyetSuVuStatus: number = 0;
  public static vanBanDenStatus: number = 0;
  public static vanBanDiStatus: number = 0;
  public static emailStatus: number = 0;
  public static sideBarActive: boolean = false;
  public static ovelayProgress: boolean = false;
  public static tokenItem: String = sessionStorage.getItem('token');

}
